import { useEffect } from "react";
import Swal from "sweetalert2";

import Image from "../../statics/illustrations/ima-modal.svg";
import useDropdow from "../../customHooks/useDropdow";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Dropdownactions from "../Dropdown/dropDownActions";
import User from "../../statics/illustrations/UserDefault.svg";
import { RiDeleteBin6Line } from "react-icons/ri";
import { logOut } from "../../store/user";
import packageInfo from "../../../package.json";
import { AiFillExclamationCircle } from "react-icons/ai";

// import { useNavigate } from "react-router";
// import Modal from "../modal";
// import MainProfile from "../../pages/dashboard/profile/mainProfile";
// import { useModal } from "../../customHooks/useModal";
interface Props {
  toggle: () => void;
}
const Avatardropdown = ({ toggle }: Props) => {
  const dev = process.env.REACT_APP_DEVELOPMENT;
  const propsDropdown = useDropdow({ placement: "bottom-end", margin: 15 });
  const { name, extra, email } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const LogOut = () => {
    dispatch(logOut());
  };

  useEffect(() => {
    if (extra.edit_status === 0) {
      Swal.fire({
        html: `Hello <b>${name}</b>, <br/> Need to update your information?`,
        imageUrl: `${Image}`,
        showCancelButton: true,
        confirmButtonText: "Let's start",
        cancelButtonText: "Maybe later",
        reverseButtons: true,
        customClass: {
          cancelButton: "button_options__button-primary",
          confirmButton: "button_options__button-secondary",
        },
        buttonsStyling: false,
      }).then((onConfirm) => {
        if (onConfirm.isConfirmed) {
          toggle();
        }
      });
    }
  }, []);

  const clearCacheData = () => {
    /* caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    }); */
    alert("variable: " + dev);
  };

  const onMyProfile = () => {
    toggle();
    propsDropdown.setisOpen((o) => !o);
  };
  const Menu = (
    <div className="c-options-profile">
      <div className="c-options-profile__section">
        <div className="c-options-profile__box-profile">
          <img
            src={
              extra?.avatar === "" ||
              extra?.avatar === null ||
              extra?.avatar === "default"
                ? User
                : extra?.avatar
            }
            alt="employ"
            className="c-options-profile__data-avatar"
          />
          <div className="c-options-profile__box-info">
            <span className="c-options-profile__info-name">{name}</span>
            <span className="c-options-profile__info-email">{email}</span>
          </div>
        </div>
      </div>
      <div className="c-options-profile__section c-options-profile__section--options">
        <div className="c-options-profile__item" onClick={onMyProfile}>
          My Profile
        </div>
        {extra.edit_status === 0 && (
          <div
            style={{
              fontSize: "12px",
              color: "red",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <AiFillExclamationCircle
              style={{ width: "20px", height: "20px", marginRight: "5px" }}
            />{" "}
            Need to update your information
          </div>
        )}
      </div>
      <div className="c-options-profile__section c-options-profile__section--options">
        <div className="c-options-profile__item" onClick={LogOut}>
          Sign Out
        </div>
      </div>
      <div className="c-options-profile__section c-options-profile__section--options">
        <div className="c-options-profile__box-item-information">
          <span className="c-options-profile__item-information">
            Version: {packageInfo.version}
          </span>
          <span
            className="c-options-profile__item-icon"
            onClick={clearCacheData}
          >
            <RiDeleteBin6Line />
          </span>
        </div>
      </div>
    </div>
  );
  return (
    <>
      <Dropdownactions overlay={Menu} {...propsDropdown}>
        <div className="c-header__option">
          <img
            src={
              extra?.avatar === "" ||
              extra?.avatar === null ||
              extra?.avatar === "default"
                ? User
                : extra?.avatar
            }
            alt="employ"
            className="c-header__avatar"
          />
        </div>
      </Dropdownactions>
    </>
  );
};

export default Avatardropdown;
